module.exports = __webpack_public_path__ + "static/media/step3.e63ef649.png";